export const vsName = 'singleReportDownloader'

import angular from 'angular'
import { SingleReportDownloaderController } from './controller'

const template: string = require('./index.html')

export const directive: angular.IDirectiveFactory = function (): angular.IDirective {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    controller: SingleReportDownloaderController,
    controllerAs: 'ctrl',
    bindToController: {
      reportGroup: '=',
      entityId: '='
    },
    scope: {

    }
  }
}